namespace PaperTrail.NewsletterControl {
    export class PageTemplateSectionColumns {
        static columnsKey = 'NewsletterControl.PageTemplateSection';
    }
}
